import { IBOMSearchResultListVM } from '../../models/response/IBOMSearchResponse';

const initialOrderTableViewState: IBOMSearchResultListVM = {
  BOMSearchResults: [],
  PagingDetails: {
    TotalRecords: 0,
    TotalPages: 0,
    CurrentPage: 0,
    PageSize: 0,
  },
};

export default initialOrderTableViewState;
